module.exports = __webpack_public_path__ + "twilio.4f6a36.svg";